import { connect } from "react-redux";

import CitiesHistogramChart from "../../components/visualizations/cities_histogram_chart";
import { onExportDefault } from "../../actions/slide_decks";

const mapStateToProps = (state) => {
  const ld = state.main.loading.loadedData;
  if (!(ld.mainChart)) { return {}; }

  const dataAndOptions = ld.mainChart;
  const currentYear = state.main.filters.year.selectedValue.value;
  const title = `Price distribution for ${currentYear} selected cities vs their regions`;
  const showExportButton = !state.main.slideDecks.slideDeckBeingSaved;

  return { dataAndOptions, title, showExportButton };
};

const mapDispatchToProps = dispatch => ({
  exportChart: onExportDefault(dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CitiesHistogramChart);
